import { displayDate } from "~/plugins/functions/display";

// For DTO PresetAssociation
export interface IModelGETPresetAssociationPresetResponse {
  id: string;
  name: string;
  description: string;
  modelName: string;
  tools: any;
  knowledgeBase: any;
  commandDetail: string;
  beginningMessage: string;
  toolSearchWeb: boolean;
  toolCanvas: boolean;
  toolDallEImage: boolean;
  toolCode: boolean;
  toolCodeText: any;
  versionCount: string;
  avatarFilePath: string;
  dbType: any;
  dbHost: any;
  dbPort: any;
  dbUsername: any;
  dbPassword: any;
  dbName: any;
  dbSchema: any;
  status: string;
  versionInUse: boolean;
  versionIsLatest: boolean;
  versionKey: string;
  isDuplicatedForUpdate: boolean;
  duplicatedFromId: any;
  duplicatedPendingId: any;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
  files: IModelGETPresetAssociationPresetFilesResponse[];
  beginningMessages: IModelGETPresetAssociationPresetBeginningMessagesResponse[];
  links: IModelGETPresetAssociationPresetLinksResponse[];
  databases: IModelGETPresetAssociationPresetDatabasesResponse[];
  isExternal: boolean;
}

export interface IModelGETPresetAssociationPresetFilesResponse {
  id: string;
  presetId: string;
  fileName: string;
  filePath: string;
  fileSize: string;
  mimeType: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
}

export interface IModelGETPresetAssociationPresetBeginningMessagesResponse {
  id: string;
  presetId: string;
  message: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
  isFavorite: boolean;
}

export interface IModelGETPresetAssociationPresetLinksResponse {
  id: string;
  presetId: string;
  link: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
}

export interface IModelGETPresetAssociationPresetDatabasesResponse {
  id: string;
  presetId: string;
  dbId: string;
  dbType: string;
  dbHost: string;
  dbPort: string;
  dbUsername: string;
  dbPassword: string;
  dbName: string;
  dbSchema: string;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  softDeleted: boolean;
}

export class ModelGETPresetAssociationPresetBeginningMessages {
  id: string;
  presetId: string;
  message: string;
  createdAt: string | Date;
  createdBy: any | null;
  updatedAt: string | Date;
  updatedBy: any | null;
  softDeleted: boolean;

  name: string;
  isFavorite: boolean;

  constructor(props = {} as IModelGETPresetAssociationPresetBeginningMessagesResponse) {
    props = props ?? {} as IModelGETPresetAssociationPresetBeginningMessagesResponse;
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.message = props.message || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
    this.name = this.message;
    this.isFavorite = props.isFavorite || false;
  }
}

export class ModelGETPresetAssociationPresetLinks {
  id: string;
  presetId: string;
  link: string;
  createdAt: string | Date;
  createdBy: any | null;
  updatedAt: string | Date;
  updatedBy: any | null;
  softDeleted: boolean;

  constructor(props = {} as IModelGETPresetAssociationPresetLinksResponse) {
    props = props ?? {} as IModelGETPresetAssociationPresetLinksResponse;
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.link = props.link || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
  }
}


export class ModelGETPresetAssociationPresetFiles {
  id: string;
  presetId: string;
  fileName: string;
  filePath: string;
  fileSize: string;
  mimeType: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;

  name: string;
  file: Blob | null;
  url: string;

  constructor(props = {} as IModelGETPresetAssociationPresetFilesResponse) {
    props = props ?? {} as IModelGETPresetAssociationPresetFilesResponse;
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.fileName = props.fileName || '';
    this.filePath = props.filePath || '';
    this.fileSize = props.fileSize || '';
    this.mimeType = props.mimeType || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;

    this.name = this.fileName;
    this.file = null;
    this.url = this.filePath;
  }
}

export class ModelGETPresetAssociationPresetDatabases {
  id: string;
  presetId: string;
  dbId: string;
  dbType: string;
  dbHost: string;
  dbPort: string;
  dbUsername: string;
  dbPassword: string;
  dbName: string;
  dbSchema: string;
  createdAt: string | Date;
  createdBy: string | null;
  updatedAt: string | Date;
  updatedBy: string | null;
  softDeleted: boolean;

  constructor(props = {} as IModelGETPresetAssociationPresetDatabasesResponse) {
    props = props ?? {} as IModelGETPresetAssociationPresetDatabasesResponse;
    this.id = props.id || '';
    this.presetId = props.presetId || '';
    this.dbId = props.dbId || '';
    this.dbType = props.dbType || '';
    this.dbHost = props.dbHost || '';
    this.dbPort = props.dbPort || '';
    this.dbUsername = props.dbUsername || '';
    this.dbPassword = props.dbPassword || '';
    this.dbName = props.dbName || '';
    this.dbSchema = props.dbSchema || '';
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
  }
}

export class ModelGETPresetAssociationPreset {
  id: string;
  name: string;
  description: string;
  modelName: string;
  tools: any;
  knowledgeBase: any;
  commandDetail: string;
  beginningMessage: string;
  toolSearchWeb: boolean;
  toolCanvas: boolean;
  toolDallEImage: boolean;
  toolCode: boolean;
  toolCodeText: any;
  versionCount: string;
  avatarFilePath: string;
  dbType: any;
  dbHost: any;
  dbPort: any;
  dbUsername: any;
  dbPassword: any;
  dbName: any;
  dbSchema: any;
  status: string;
  versionInUse: boolean;
  versionIsLatest: boolean;
  versionKey: string;
  isDuplicatedForUpdate: boolean;
  duplicatedFromId: any;
  duplicatedPendingId: any;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
  softDeleted: boolean;
  filesList: ModelGETPresetAssociationPresetFiles[];
  beginningMessagesList: ModelGETPresetAssociationPresetBeginningMessages[];
  linksList: ModelGETPresetAssociationPresetLinks[];
  databasesList: ModelGETPresetAssociationPresetDatabases[];


  avatarFile: any;
  displayCreatedAt: string;
  displayUpdatedAt: string;
  beginningMessagesFavoriteList: ModelGETPresetAssociationPresetBeginningMessages[];
  isExternal: boolean;

  constructor(props = {} as IModelGETPresetAssociationPresetResponse) {
    props = props ?? {} as IModelGETPresetAssociationPresetResponse;
    this.id = props.id || '';
    this.name = props.name || '';
    this.description = props.description || '';
    this.modelName = props.modelName || '';
    this.tools = props.tools || null;
    this.knowledgeBase = props.knowledgeBase || null;
    this.commandDetail = props.commandDetail || '';
    this.beginningMessage = props.beginningMessage || '';
    this.toolSearchWeb = props.toolSearchWeb || false;
    this.toolCanvas = props.toolCanvas || false;
    this.toolDallEImage = props.toolDallEImage || false;
    this.toolCode = props.toolCode || false;
    this.toolCodeText = props.toolCodeText || null;
    this.versionCount = props.versionCount || '';
    this.avatarFilePath = props.avatarFilePath || '';
    this.dbType = props.dbType || null;
    this.dbHost = props.dbHost || null;
    this.dbPort = props.dbPort || null;
    this.dbUsername = props.dbUsername || null;
    this.dbPassword = props.dbPassword || null;
    this.dbName = props.dbName || null;
    this.dbSchema = props.dbSchema || null;
    this.status = props.status || '';
    this.versionInUse = props.versionInUse || false;
    this.versionIsLatest = props.versionIsLatest || false;
    this.versionKey = props.versionKey || '';
    this.isDuplicatedForUpdate = props.isDuplicatedForUpdate || false;
    this.duplicatedFromId = props.duplicatedFromId || null;
    this.duplicatedPendingId = props.duplicatedPendingId || null;
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;
    this.softDeleted = props.softDeleted || false;
    this.filesList = (props.files || []).map((e) => new ModelGETPresetAssociationPresetFiles(e));
    this.beginningMessagesList = (props.beginningMessages || []).map((e) => new ModelGETPresetAssociationPresetBeginningMessages(e));
    this.linksList = (props.links || []).map((e) => new ModelGETPresetAssociationPresetLinks(e));
    this.databasesList = (props.databases || []).map((e: IModelGETPresetAssociationPresetDatabasesResponse) => new ModelGETPresetAssociationPresetDatabases(e));


    this.avatarFile = this.avatarFilePath ? {
      url: undefined,
    } : undefined;
    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTime: true
    });
    this.beginningMessagesFavoriteList = this.beginningMessagesList.filter(e => e.isFavorite);
    this.isExternal = props.isExternal || false;
  }
}

export interface IModelPresetActiveResponse {
  id: number;
  name: string;
  preset: {
    name: string
  }
  presetId: string;
}

export class ModelPresetActive {
  id: number;
  name: string;
  presetId: string;

  constructor(props = {} as IModelPresetActiveResponse) {
    this.id = props.id;
    this.name = props.preset ? props.preset.name : '';
    this.presetId = props.presetId || ''
  }
}